// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9526":"e1db1291","9852":"9d0083fd"}[chunkId] + ".chunk.css";
};